import { Component, HostListener, OnInit } from '@angular/core';
import { LocalStorageProps } from '@commoncore/enums/localStorageProps';
import { GlobalService } from '@commoncore/services/global.service';
import { AppEvents, EventsList } from '@commoncore/utils/app-events';
import { ENV_CONSTANTS } from '@env-properties/environment';

@Component({
  selector: 'common-downtime-banner',
  templateUrl: './downtime-banner.component.html',
  styleUrl: './downtime-banner.component.scss'
})
export class DowntimeBannerComponent implements OnInit {
  universalService: any;
  cleverTapEventsService: any;
  router: any;
  openPreviousModal: any;
  localStorageService: any;
  
  constructor(public globalService: GlobalService) {
    this.setEnvObjects(globalService);
    AppEvents.globalObservable.subscribe(ev=>{ 
      if(ev["downTimeBanner"] == true){
        this.showPreviouslyOpenModal();
      }
    })
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent) {
    if (event.key === "Escape" && this.universalService.isDowntimeBannerModal == true) {
      this.closeBanner();
    }
  }

  async ngOnInit(): Promise<void> {
    var self = this;

    self.showBanner();
    AppEvents.on(EventsList.DOWNTIME_BANNER, function(){
      if(self.getTimeDifference()) {
        setTimeout(async ()=>{
          self.showBanner();
        },400);
      } else {
        self.universalService.isDowntimeBannerModal = false;
      }
    });
  }
  
  setEnvObjects(globalService){
    this.universalService = this.globalService.getUniversalServiceRef();
    this.router = globalService.getRouterRef();
    this.cleverTapEventsService = this.globalService.getCleverTapEventsvc();
    this.localStorageService = globalService.getLocalStorageSvcRef();
  }

  handleAlreadyOpenedModal(){
    setTimeout(()=>{
      let openModalList = document.querySelectorAll('.modal.fade');
      openModalList.forEach(modal => {
        let style = window.getComputedStyle(modal)
        if(style.getPropertyValue('display') == 'block' && modal.id != 'downtime-banner-modal' && modal.id != 'blocking-banner-modal' && modal.id != 'passphraseModalloginModal' && modal.id != 'preview-modal'){
          this.openPreviousModal = modal.id;
          (modal as any).style.setProperty('display', 'none');
        }
      });
    })
  }

  showPreviouslyOpenModal(){
    this.universalService.disableModalBackdrop();
    this.universalService.isDowntimeBannerModal = false;
    if(this.openPreviousModal){
      this.universalService.showModalBackdrop();
      document.getElementById(this.openPreviousModal).style.display = "block";
    }
  }

  closeBanner(){
    this.universalService.disableModalBackdrop();
    this.universalService.isDowntimeBannerModal = false;
  }

  async showBanner() {
    var self = this;
    self.universalService.isDowntimeBannerModal = true;
    self.updatBannerTime();
    await self.handleAlreadyOpenedModal();
  }

  updatBannerTime() {
    var tokenTime = (new Date().getTime()  + (ENV_CONSTANTS["constants"]["downTimeBanner"] * 60 * 1000));
    this.localStorageService.setItem(LocalStorageProps.DOWNTIME_BANNER, tokenTime);
  }

  getTimeDifference() {
    var currentTime = new Date().getTime();
    var localTime = this.localStorageService.getItem(LocalStorageProps.DOWNTIME_BANNER);
    if(localTime == null) {
        localTime = 0;
    }

    if(localTime < currentTime) {
        return true;
    }
    return false;
  }
}
